/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';

export default class SubscriptionsFilter {
    filterHandlers = {
        update: 'subscriptionsFilter/updateFilter',
        reset: 'subscriptionsFilter/resetFilter', 
        resetState: 'subscriptionsFilter/resetFilterState',
        removeSelected: 'subscriptionsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createDatePickerEntity('startAtMain');
        filter.setPlaceholder('startAtMain', 'По дате начала');
        filter.setName('startAtMain', 'search_startAtMain');
        filter.setPreviewName('startAtMain', 'Дата начала');
        filter.setClassName('startAtMain', 'col-1-row-1');
        filter.setIconClassName('startAtMain', 'icon-clock');
        filter.setAction('startAtMain', 'subscriptionsFilter/updateDate');

        filter.createDatePickerEntity('endAtMax');
        filter.setPlaceholder('endAtMax', 'По дате окончания');
        filter.setName('endAtMax', 'search_endAtMax');
        filter.setPreviewName('endAtMax', 'Дата окончания');
        filter.setClassName('endAtMax', 'col-1-row-2');
        filter.setIconClassName('endAtMax', 'icon-clock');
        filter.setAction('endAtMax', 'subscriptionsFilter/updateDate');

        filter.createRadioEntity('isActive');
        filter.setTitle('isActive', 'Подписка активна');
        filter.setName('isActive', 'radio_is_active');
        filter.setIconClassName('startAtMain', 'icon-check-line');
        filter.setPreviewName('isActive', 'Актив');
        filter.setRadioList('isActive', [
            { id: 0, name: 'Активна', checked: false },
            { id: 1, name: '', checked: false },
            { id: 2, name: 'Не активна', checked: false },
        ]);
        filter.setAction('isActive', 'subscriptionsFilter/updateRadio');
        filter.setClassName('isActive', 'col-1-row-3');

        this.filterModel = filter.filterModel;
    }
}
